import { render, staticRenderFns } from "./IconAnnouncement.vue?vue&type=template&id=489ad12d"
import script from "./IconAnnouncement.vue?vue&type=script&lang=js"
export * from "./IconAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports